import { Container } from "../atoms/Container";

type SiteKeepsakeQuoteProps = {
  mobile?: boolean;
};

export function SiteKeepsakeQuote({ mobile = false }: SiteKeepsakeQuoteProps) {
  const pad = mobile ? 24 : 96;
  return (
    <section
      style={{
        paddingTop: mobile ? 96 : 192,
        paddingBottom: mobile ? 96 : 192,
      }}
    >
      <Container pad={pad}>
        <blockquote
          style={{
            margin: 0,
            fontFamily: "var(--display)",
            fontStyle: "italic",
            fontWeight: 400,
            fontSize: mobile ? "clamp(28px, 8vw, 36px)" : "clamp(36px, 4vw, 52px)",
            lineHeight: 1.18,
            letterSpacing: "-0.02em",
            color: "var(--text-2)",
            maxWidth: 880,
          }}
        >
          A year ago you had not run a mile.
          <br />
          Today you ran twenty-six.
        </blockquote>
      </Container>
    </section>
  );
}
